import Navigation from 'components/shared/Navigation/Navigation'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Menu } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationSubmenuCategories extends React.Component {
  render() {
    const { items, push, hideSidebar, node } = this.props

    const menuItems = items.map((item) => (
      <Menu.Item
        {...{
          active: item.active,
          href: item.path,
          key: item.key,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}>
        <div className="title ellipsis">{item.content}</div>
        <div className="unobtrusive">{Math.round(Math.random() * 20)}</div>
      </Menu.Item>
    ))

    const menu = (
      <Menu.Item>
        <Navigation render="title" as="link" node={node} />
        <Menu.Menu size="small">{menuItems}</Menu.Menu>
      </Menu.Item>
    )

    return menuItems ? menu : false
  }
}

NavigationSubmenuCategories = connect(mapStateToProps, mapDispatchToProps)(
  NavigationSubmenuCategories
)
export default NavigationSubmenuCategories



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationSubmenuCategories.jsx